import type { FunctionComponentWithRef } from "react";

import type { ContainerProps } from "./styles";
import { Container, CountMessage, NoPostMessage, StyledButton, StyledCommentIcon } from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement> & {
  className?: string;
  commentCount: number;
  onClick?: () => void;
  variant?: ContainerProps["$variant"];
};

export const ArticleCommentsWidget: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  commentCount,
  onClick,
  ref: forwardReference,
  variant,
}) => (
  <Container $variant={variant} className={className} ref={forwardReference}>
    {commentCount > 0 ? (
      <CountMessage>{commentCount}</CountMessage>
    ) : (
      <NoPostMessage>Post</NoPostMessage>
    )}
    <StyledButton onClick={onClick}>
      <StyledCommentIcon />
    </StyledButton>
  </Container>
);

ArticleCommentsWidget.displayName = "ArticleCommentsWidget";
